// THE DESK'S OWN ACCOUNTS ARE READ ON TREASURY, NEVER ON A PARTY PAGE.
//
// Operator, 23 Sept 2026: "move this to treasury only, we already have it separately and groups as well". Again on
// 21 Oct 2026: "in party, I am still seeing treasury accounts, which it should't display and anyway it's wrong" — the
// 23 Sept change left three doors open (a typed search on Parties, the command palette, the Wallet register's link),
// and a desk account's party page has no balances, no wallets and no statement: its money is on the account.
//
// One place says it, so the Parties list, the palette, the register's link and the party route cannot disagree. The
// Parties API is untouched: sixteen screens read own accounts from it (the register's owner picker, Record money, Adjust,
// Treasury swap, …) — only what the Parties SCREEN lists and where an own account OPENS changed.

/** A desk account, or a folder of them — not a customer or a merchant. */
export const isOwnAccount = (p: { party_type?: string | null }): boolean => p.party_type === 'own_account';

/** What the Parties list shows: customers and merchants. */
export function partiesOnly<T extends { party_type?: string | null }>(rows: readonly T[]): T[] {
  return rows.filter((p) => !isOwnAccount(p));
}

/** Where an own account is read: its row on Treasury, opened (`/treasury?rail=<treasury slug>`). A folder has no
 *  treasury slug of its own and opens Treasury plain. */
export function treasuryHref(treasurySlug: string | null | undefined): string {
  return treasurySlug ? `/treasury?rail=${encodeURIComponent(treasurySlug)}` : '/treasury';
}
